'use client';
import { Button } from "@/components/ui/button";
import { FcGoogle } from "react-icons/fc";
import { FaLinkedin } from "react-icons/fa6";
import { signIn } from "next-auth/react"
import { JSX } from "react";

const ProviderIcons: { [key: string]: JSX.Element } = {
    Google: <FcGoogle size={24} style={{marginRight: 10 }} />,
    Linkedin: <FaLinkedin size={24} style={{marginRight: 10 }} />
}


export async function LoginButton(props: {providerName: string, providerId: string}) {
    return (
        <Button style={{width: '100%'}} onClick={() => signIn(props.providerId)}>{ProviderIcons[props.providerName]} Signup with {props.providerName}</Button>
    );
}